import styled from 'styled-components';

export const RecommendationsContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export const RecommendationsHeader = styled.div`
	text-align: center;
	margin-bottom: 20px;
`;

export const RecommendationsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	max-width: 100%;
`;

export const LoadingContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 200px;
	color: #666;
`;

export const EmptyState = styled.div`
	text-align: center;
	padding: 40px 20px;
	color: #666;
`;

export const EmptyStateIcon = styled.div`
	font-size: 48px;
	margin-bottom: 16px;
`;

export const EmptyStateText = styled.div`
	font-size: 16px;
`;

export const StyledRecommendationsCard = styled.div`
	min-width: 800px;
	width: 800px;
	min-height: 600px;
	padding: 30px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
	border-radius: 20px;
	background: #fff;
	flex-shrink: 0;
	scroll-snap-align: center;

	/* Entrance animation */
	animation: slideInFromRight 0.6s cubic-bezier(0.4, 0, 0.2, 1);

	@keyframes slideInFromRight {
		from {
			opacity: 0;
			transform: translateX(50px) scale(0.95);
		}
		to {
			opacity: 1;
			transform: translateX(0) scale(1);
		}
	}
`;

export const DescriptionText = styled.div`
	margin-top: 8px;
`;

export const StyledContentCard = styled.div`
	background-color: #1a365d;
	border-radius: 8px;
	padding: 12px;
	color: white;

	/* Force white text for emotion detector cards */
	* {
		color: white !important;
	}
`;
